module.exports = __webpack_public_path__ + "media/Winner Sticker.7580d08b.mp3";